import "./styles.scss";

import moment from "moment";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { decryptIfEncrypted } from "../../../utils/fieldDecryptor";

function CardLatestSchedule() {
  const { t } = useTranslation();
  const { allLastSchedules } = useSelector((state) => state.genericReducer);

  const isPendingByTeacher = (item) => item?.status === "pendent" || item?.status === "pendent-delayed";

  const renderContentCode = (item) => {
    if (item?.classFocus?.toLowerCase() === "specific") return t("BTN_SPECIFIC");
    return item.contentCode ?? "-";
  };

  if (allLastSchedules.length === 0) return <div />;

  return (
    <div className="containerCardLatestSchedule">
      <h4 className="title">{t("LATEST_APPOINTMENTS")}</h4>

      <div className="contentCardLatestSchedule">
        <div className="headerTable">
          <p>{t("DATE")}</p>
          <p>{t("CODE")}</p>
          <p>{t("TEACHER")}</p>
        </div>

        <div className="bodyTable">
          {allLastSchedules?.slice(0, 10)?.map((item) => (
            <div key={item.id} className={isPendingByTeacher(item) && "canceled"}>
              <p>{moment(item.classDateTimeAt).format(t("DATE_FORMAT"))}</p>
              <p>{renderContentCode(item)}</p>
              <p>{decryptIfEncrypted(item.teacherName)}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CardLatestSchedule;
